import { render, staticRenderFns } from "./UnitVisits.vue?vue&type=template&id=22f7298b"
import script from "./UnitVisits.vue?vue&type=script&lang=js"
export * from "./UnitVisits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports